import { render, staticRenderFns } from "./PlanMatching.vue?vue&type=template&id=61482ce8&scoped=true"
import script from "./PlanMatching.vue?vue&type=script&lang=js"
export * from "./PlanMatching.vue?vue&type=script&lang=js"
import style0 from "./PlanMatching.vue?vue&type=style&index=0&id=61482ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61482ce8",
  null
  
)

export default component.exports